import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  open: false,
  title: '',
  message: '',
  onAgreeAction: '',
  onDismissAction: '',
  isOrderDeclineAlert: false,
  note: '',
  blockUser: false,
});

export const openAlert = createAction('OpenAlert');
export const closeAlert = createAction('CloseAlert');
export const blockUserCheckBoxClicked = createAction('BLOCKUSERCHECKBOXCLICKED');
export const noteTextFieldChanged = createAction('NOTETEXTFIELDCHANGED');

const reducers = createReducer({
  [openAlert]: (state, { title, message, onAgreeAction, onDismissAction, isOrderDeclineAlert}) =>
    state.merge({ title, message, onAgreeAction, onDismissAction, open: true, isOrderDeclineAlert, note: '', blockUser: false}),
  [closeAlert]: state => state.merge({ open: false }),
  [blockUserCheckBoxClicked]: state => state.merge({blockUser: !state.blockUser}),
  [noteTextFieldChanged]: (state, newValue) => state.merge({note: newValue}),
}, INITIAL_STATE);

export default reducers;
